import React, { useEffect, useState, useRef } from "react";

import Header from "../Header";
import LeftNavBar from "../LeftNavBar";
import PageHeader from "../PageHeader";
import { useMemo } from "react";
import { useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import { PrimaryButton } from "../../StyledCss/styledbtn";
import { PageHeaderName } from "../../StyledCss/styledComponents";
import PopupModal from "../PopupModal";
import "./index.css";
import FailureView from "../FailureView";
import PositiveNumberEditor from "../PositiveNumberCell";
import DateCellEditor from "../DateCellEditor";
import LoadingView from "../LoadingView";
import { Download } from "lucide-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Mail } from "lucide-react";
import {
  getProjects,
  getAllInvoices,
  getDownloadAllInvoices,
  UpdateInvoiceData,
  getEmailTemplates,
  sendEmail,
  exportInvoiceExcelTemplate,
  importInvoiceTemplate,
  strikeOffInvoice,
  getInvoiceSequenceNumber,
  updateInvoiceSequenceNumber,
} from "../../api/services/hroneApi";
import { XCircle } from "lucide-react";
import { SecondaryButton } from "../../StyledCss/styledbtn";
import toast from "react-hot-toast";
import { StyledLabel, StyledSelect, StyledSelectContainer, StyledSelectGroup } from "../../StyledCss/styledInputs";
import UploadExcelForm from "../UploadExcelFile/uploadExcelFile";
import { convertKeysToCamelCase } from "../../util/convertCamelCase";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";

const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
}; 
const MonthsData = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

const InvoiceManagementDashBoard = () => {
  const { hasPermission, hasAnyPermission } = usePermissions();
  const canEditInvoice = hasPermission(FEATURE_CODES.INVOICE_EDIT);
  const canDownloadInvoice = hasPermission(FEATURE_CODES.INVOICE_DOWNLOAD);
  const canStrikeOff = hasPermission(FEATURE_CODES.INVOICE_STRIKE_OFF);
  const canSendEmail = hasPermission(FEATURE_CODES.INVOICE_SEND_EMAIL);
  const canDownloadAll = hasPermission(FEATURE_CODES.INVOICE_DOWNLOAD_ALL);
  const canSequenceEdit = hasPermission(FEATURE_CODES.INVOICE_SEQUENCE_EDIT);
  const canImportOrExport = hasAnyPermission([
    FEATURE_CODES.INVOICE_IMPORT,
    FEATURE_CODES.INVOICE_EXPORT,
  ]);
  const [loadingStates, setLoadingStates] = useState({
    sendInvoice: false,
    invoiceNumber: false,
    strikeOff : false,
  });
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.success);
  const [strikeOffReason, setStrikeOffReason] = useState("");
  const [projectsData, setProjectsData] = useState([]);
  const [projectsAccessDenied, setProjectsAccessDenied] = useState(false);
  const [emailTemplatesData,setEmailTemplatesData]=useState([])
  const [emailTemplatesAccessDenied, setEmailTemplatesAccessDenied] = useState(false);
  const [invoiceNumberAccessDenied, setInvoiceNumberAccessDenied] = useState(false);
  const [isInvoiceSequenceNumberModalOpen, setIsInvoiceSequenceNumberModalOpen] = useState(false);
  const [invoiceNumberInput, setInvoiceNumberInput] = useState("");
  const [invoiceNumberError, setInvoiceNumberError] = useState("");
  const [isStrikeOffModalOpen, setIsStrikeOffModalOpen] = useState(false);
  const [strikeOffId, setStrikeOffId] = useState(null);
  const [isSendEmailModalOpen, setIsSendEmailModalOpen] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [currenySummary, setCurrencySummary] = useState([]);
  const [invoicesData, setInvoicesData] = useState([]);
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const [openPopupExcel, setOpenPopupExcel] = useState(false);
  const dropdownRef = useRef(null);
  const [yearsList, setYearsList] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(
    String(new Date().getMonth() + 1).padStart(2, "0"),
  );
  const [selectedYear, setSelectedYear] = useState(
    String(new Date().getFullYear()),
  );
  const cancelStrikeOff = () => {
    setIsStrikeOffModalOpen(false);
    setLoadingStates({ strikeOff: false });
    setStrikeOffReason("");
    setStrikeOffId(null);
  };
  const cancelSendEmail = () => {
    setIsSendEmailModalOpen(false);
    setSelectedTemplateId("");
    setSelectedInvoiceId(null);
  };

  const handleSendEmail = async () => {
    try {
      setLoadingStates({ sendInvoice: true });
      const payload = selectedInvoiceId 
        ? { template_id: selectedTemplateId, invoice_id: selectedInvoiceId }
        : { template_id: selectedTemplateId };
      const response = await sendEmail(payload);
      if (response.ok) {
        toast.success("Emails sent successfully");
        fetchInvoices();
        cancelSendEmail();
      } else {
        toast.error("Failed to send emails");
      }
    } catch (error) {
      toast.error("Failed to send emails");
      console.error("Error sending emails:", error);
    } finally {
      setLoadingStates({ sendInvoice: false });
    }
  };
  const handleProjectChange =  async (e) => {
      const projectId = e.target.value;
      setSelectedProject(projectId);
    };
  
  
    const emailTemplates = useCallback(async () => {
    try {
      const response = await getEmailTemplates();

      if (response.ok) {
        const data = convertKeysToCamelCase(await response.json());
        setEmailTemplatesData(data.data);
        setEmailTemplatesAccessDenied(false);
      } else {
        setEmailTemplatesAccessDenied(response.status === 403);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  }, []);

  const invoiceNumber =async () => {
    try {
      const response = await getInvoiceSequenceNumber();

      if (response.ok) {
        const data = await response.json();
        setInvoiceNumberInput(data.invoice_number);
        setInvoiceNumberAccessDenied(false);
      } else {
        setInvoiceNumberAccessDenied(response.status === 403);
      }
    } catch (error) {
      console.error("Error fetching invoice number:", error);
    }
  }
  


  const saveInvoiceNumber = async () => {
    try {
      setLoadingStates({ invoiceNumber: true });
      const payload = { invoice_number: Number(invoiceNumberInput.trim()) };
      const response = await updateInvoiceSequenceNumber(payload);
      if (response.ok) {
        toast.success("Invoice number saved successfully");
        cancelInvoiceNumberModal();
      } else {
        const data = await response.json();
        setInvoiceNumberError(data?.detail || data?.message || "Failed to save invoice number");
      }
    } catch (error) {
      console.error("Error saving invoice number:", error);
      toast.error("Failed to save invoice number");
    } finally {
      setLoadingStates({ invoiceNumber: false });
    }
  };

  const getProjectsList = useCallback(async () => {
    try {
      const response = await getProjects();

      if (response.ok) {
        const data = await response.json();
        setProjectsData(data);
        setProjectsAccessDenied(false);
      } else {
        setProjectsAccessDenied(response.status === 403);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  }, []);
  const DownloadAllInvoices = useCallback(async () => {
    try {
      setIsDownloading(true);
      const response = await getDownloadAllInvoices(selectedProject);

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const monthName =
          MonthsData.find((m) => m.value.trim() === selectedMonth)?.label ||
          selectedMonth;
        link.download = `${monthName} - invoices.zip`;
        link.click();
        window.URL.revokeObjectURL(url);
        setIsDownloading(false);
      } else {
        setIsDownloading(false);
      }
    } catch (error) {
      console.error("Error downloading invoices:", error);
      setIsDownloading(false);
    }
  }, [selectedMonth, selectedProject]);

  const handleDownloadInvoice = (url, name) => {
      // const fileUrl = url.split("?")[0];

    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    link.click();
  };
  // const handleViewInvoice = (url) => {
  //     window.open(url, "_blank");


  // }
    const cancelInvoiceNumberModal = () => {
    setIsInvoiceSequenceNumberModalOpen(false);
    setInvoiceNumberError("");
  };
   const openInvoiceNumberModal = () => {
    setIsInvoiceSequenceNumberModalOpen(true);
  };
  const handleStrikeOff = (invoiceId) => {
    setStrikeOffId(invoiceId);
    setIsStrikeOffModalOpen(true);
  };

  const confirmStrikeOff = async () => {
    try {
      setLoadingStates({ strikeOff: true });
      const response = await strikeOffInvoice({ invoice_id: strikeOffId, reason: strikeOffReason });
      if (response.ok) {
        toast.success("Invoice struck off successfully");
        fetchInvoices();
      } else {
        toast.error("Failed to strike off invoice");
      }
    } catch (error) {
      toast.error("Failed to strike off invoice");
      console.error("Error striking off invoice:", error);
    } finally {
      setLoadingStates({ strikeOff: false });
      setIsStrikeOffModalOpen(false);
      setStrikeOffReason("");
      setStrikeOffId(null);
    }
  };
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = new Date().getFullYear() - 4;
    const years = Array.from(
      { length: currentYear - startYear + 1 },
      (_, index) => {
        const yearValue = startYear + index;
        return { label: yearValue.toString(), value: yearValue.toString() };
      },
    );

    setYearsList(years.reverse());
  }, []);

  const fetchInvoices = useCallback(async () => {
    try {
      setApiStatus(apiStatusConstants.inProgress);
      const response = await getAllInvoices(
        selectedProject,
        selectedMonth,
        selectedYear,
      );

      if (response.ok) {
        const data = convertKeysToCamelCase(await response.json());
        setInvoicesData(data.invoices);
        setCurrencySummary(data.currencySummary);
        setApiStatus(apiStatusConstants.success);
      } else {
        setApiStatus(apiStatusConstants.failure);
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
      setApiStatus(apiStatusConstants.failure);
    }
  }, [selectedMonth, selectedYear, selectedProject]);

  useEffect(() => {
    getProjectsList();
    emailTemplates();
    invoiceNumber();
    // eslint-disable-next-line
  }, []);

  useEffect(()=>{
        fetchInvoices();
        // eslint-disable-next-line
  },[selectedMonth, selectedYear, selectedProject])

  const onClickRetry = () => {
    getProjectsList();
    emailTemplates();
    fetchInvoices();
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsFilterDropdownOpen(false);
      }
    };

    if (isFilterDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isFilterDropdownOpen]);

  const updateInvoiceField = useCallback(async (params, field, newValue, successMessage) => {

    const payload = {
      id: params.data.id,
      [field]: newValue
    };

    try {
      const response = await UpdateInvoiceData(payload);
      if (response.ok) {
        toast.success(successMessage);
        fetchInvoices();
      } else {
        toast.error(`Failed to update ${field.replace('_', ' ')}`);
      }
    } catch (error) {
      toast.error(`Failed to update ${field.replace('_', ' ')}`);
      console.error(`Failed to update ${field}:`, error);
    }
    // eslint-disable-next-line
  }, [selectedProject, selectedMonth, selectedYear]);

  const updateInvoiceStatus = useCallback((params, newValue) => 
    updateInvoiceField(params, 'status', newValue, 'Invoice status updated successfully'), [updateInvoiceField]);
  
  const updatePaymentStatus = useCallback((params, newValue) => 
    updateInvoiceField(params, 'payment_status', newValue, 'Payment status updated successfully'), [updateInvoiceField]);
  
  const updateReceivedAmount = useCallback((params) => 
    updateInvoiceField(params, 'received_amount', params.newValue, 'Received amount updated successfully'), [updateInvoiceField]);
  
    const updateReceivedDate = useCallback((params) => 
    updateInvoiceField(params, 'received_date', params.newValue, 'Received date updated successfully'), [updateInvoiceField]);

     const updateConversionRate = useCallback((params) => 
    updateInvoiceField(params, 'conversion_rate', params.newValue, 'Conversion rate updated successfully'), [updateInvoiceField]);

  const handleImport=useCallback(async(formData)=> {
        const response = await importInvoiceTemplate(formData);
        if (response.status === 200) 
        {
           fetchInvoices();              
        }
        return response;
        // eslint-disable-next-line
        },[selectedProject, selectedMonth, selectedYear])

  const columnDefs = useMemo(
    () => [
      {
        headerName: "INVOICE NO ",
        field: "invoiceNumber",
        width: 200,
        pinned: "left",
       cellRenderer: (params) => {
          if (params.node.rowPinned) return params.value;
          const isDefaulted = params.data?.paymentStatus === "DEFAULTED";
          const displayValue = params.data?.strikedOff
            ? params.value?.split("/").slice(0, -1).join("/")
            : params.value;
          return isDefaulted
            ? <span style={{ textDecoration: "line-through", textDecorationColor: "red", textDecorationThickness: "2px" }}>{displayValue}</span>
            : displayValue;
        },        suppressMenu: true
      },
      {
        headerName: "CLIENT NAME",
        field: "clientName",
        width: 200,
        pinned: "left",
        suppressMenu: true,
        cellRenderer: (params) => {
          if (params.node.rowPinned) return '';
          return params.value;
        },
      },
      {
        headerName: "PROJECT NAME	",
        field: "projectName",
        width: 200,
        pinned: "left",
        suppressMenu: true,
        cellRenderer: (params) => {
          if (params.node.rowPinned) return '';
          return params.value;
        },
      },
      {
        headerName: "BILLING PERIOD	",
        field: "invoiceMonthYear",
        width: 200,
        suppressMenu: true,
        tooltipField: "invoice_month_year",
        cellRenderer: (params) => {
          if (params.node.rowPinned) return '';
          return params.value;
        },
      },
      {
        headerName: "CURRENCY",
        field: "currency",
        width: 200,
        suppressMenu: true,
        tooltipField: "currency",
        cellRenderer: (params) => {
          if (params.node.rowPinned) return '';
          return params.value;
        },
      },
      {
        headerName: "AMOUNT",
        field: "totalAmount",
        width: 200,
        pinned: "left",
        suppressMenu: true,
        tooltipField: "total_amount",
        cellRenderer: (params) => {
          if (!params.data?.currency) return params.value || '';
          return (params.value || 0).toLocaleString("en-IN", { style: "currency", currency: params.data.currency });
        }
      },
      {
        headerName: "RECEIVED AMOUNT",
        field: "receivedAmount",
        width: 200,
        editable: canEditInvoice,
        suppressMenu: true,
        cellEditor: PositiveNumberEditor,
        onCellValueChanged: updateReceivedAmount,
        valueParser: (params) => {
          return parseFloat(params.newValue) || 0;
        },
        valueFormatter: (params) => {
          if (!params.data?.currency) return params.value || '';
          return (params.value || 0).toLocaleString("en-IN", { style: "currency", currency: params.data.currency });
        },
        cellRenderer: (params) => { if (params.node.rowPinned) return ''; return params.valueFormatted; },
      },
      {
        headerName: "DIFFERENCE AMOUNT",
        field: "differenceAmount",
        width: 250,
        tooltipField: "difference_amount",
        suppressMenu: true,
        valueFormatter: (params) => {
          if (!params.data?.currency) return params.value || '';
          return (params.value || 0).toLocaleString("en-IN", { style: "currency", currency: params.data.currency });
        },
        cellRenderer: (params) => { if (params.node.rowPinned) return ''; return params.valueFormatted; },
      },
      {
        headerName: "CONVERSION RATE", field: "conversionRate", width: 200, editable: canEditInvoice,
        suppressMenu: true,
        cellEditor: "PositiveNumberEditor", onCellValueChanged: updateConversionRate,
        valueParser: (params) => parseFloat(params.newValue) || 0,
        valueFormatter: (params) => `₹${(params.value || 0).toLocaleString()}`,
        cellRenderer: (params) => { if (params.node.rowPinned) return ''; return params.valueFormatted; },
      },
      {
        headerName: "CONVERTED AMOUNT", field: "convertedAmount", width: 250,
        suppressMenu: true,
        valueFormatter: (params) => `₹${params.value || 0}`,
        cellRenderer: (params) => { if (params.node.rowPinned) return ''; return params.valueFormatted; },
      },
      {
        headerName: "INVOICE STATUS",
        field: "status",
        width: 170,
        suppressMenu: true,
        tooltipField: "invoice_status",
        cellRenderer: (params) => {
          if (params.node.rowPinned) return '';
          const isDefaulted = params.data?.paymentStatus === "DEFAULTED";
          return (
            <select
              value={params.value || "not sent"}
              onChange={(e) => updateInvoiceStatus(params, e.target.value)}
              disabled={isDefaulted || !canEditInvoice}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                background: "transparent",
                fontSize: "14px",
                cursor: isDefaulted ? "not-allowed" : "pointer",
              }}
            >
              <option value="DRAFT">Draft</option>
              <option value="SENT">Sent</option>
            </select>
          );
        },
        sortable: true,
        filter: true,
      },
      {
        headerName: "SENT DATE",
        field: "sentDate",
        width: 150,
        suppressMenu: true,
        tooltipField: "sent_date",
        cellRenderer: (params) => {
          if (params.node.rowPinned) return '';
          return params.value;
        },
      },
      {
        headerName: "PAYMENT STATUS",
        field: "paymentStatus",
        width: 180,
        suppressMenu: true,
        tooltipField: "payment_status",
        cellRenderer: (params) => {
          if (params.node.rowPinned) return '';
          
          const getBackgroundColor = (status) => {
            switch(status) {
              case "PENDING": return "#fdf746";
              case "RECEIVED": return "#88E788";
              case "OVERDUE": return "#FFA500";
              case "DEFAULTED": return "#eb6f46";
              default: return "transparent";
            }
          };
          
          const isDefaulted = params.data?.paymentStatus === "DEFAULTED";
          return (
            <select
              value={params.value || "Pending"}
              onChange={(e) => updatePaymentStatus(params, e.target.value)}
              disabled={isDefaulted || !canEditInvoice}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                background: isDefaulted ? "#ccc" : getBackgroundColor(params.value),
                fontSize: "14px",
                cursor: isDefaulted ? "not-allowed" : "pointer",
              }}
            >
              <option value="PENDING" style={{ background: "white" }}>Pending</option>
              <option value="RECEIVED" style={{ background: "white" }}>Received</option>
              <option value="OVERDUE" style={{ background: "white" }}>Overdue</option>
              <option value="DEFAULTED" style={{ background: "white" }}>Defaulted</option>
            </select>
          );
        },
        sortable: true,
        filter: true,
      },
      {
        headerName: "RECIEVED DATE", field: "receivedDate", width: 200,
        editable: canEditInvoice,suppressMenu: true,
 cellEditor: DateCellEditor, onCellValueChanged: updateReceivedDate,
        cellRenderer: (params) => { if (params.node.rowPinned) return ''; return params.value; },
      },
      {
        headerName: "ACTIONS",
        width: 200,
        cellRenderer: (params) => {
          if (params.node.rowPinned) return '';
          const isDefaulted = params.data?.paymentStatus === "DEFAULTED";
          return (
            <div style={{ display: "flex", gap: "10px", alignItems: "center", height: "100%" }}>
              {canDownloadInvoice && (
                <div title="Download" className="icon-wrapper">
                  <Download
                    style={{ cursor: isDefaulted ? "not-allowed" : "pointer", color: isDefaulted ? "#ccc" : "#28a745", fontSize: "16px" }}
                    onClick={() => !isDefaulted && handleDownloadInvoice(params.data.pdfUrl, params.data.projectName)}
                  />
                </div>
              )}
              {canStrikeOff && (
                <div title="Strike off" className="icon-wrapper">
                  <XCircle
                    style={{ cursor: isDefaulted ? "not-allowed" : "pointer", color: isDefaulted ? "#ccc" : "#dc3545", fontSize: "16px" }}
                    onClick={() => !isDefaulted && handleStrikeOff(params.data.id)}
                  />
                </div>
              )}
              {canSendEmail && (
                <div title={params.data.status === "DRAFT" ? "Send email" : "Only draft invoices can be emailed"} className="icon-wrapper">
                  <Mail
                    style={{
                      cursor: (isDefaulted || params.data.status !== "DRAFT") ? "not-allowed" : "pointer",
                      color: (isDefaulted || params.data.status !== "DRAFT") ? "#ccc" : "#007bff",
                      fontSize: "16px",
                    }}
                    onClick={() => {
                      if (!isDefaulted && params.data.status === "DRAFT") {
                        setSelectedInvoiceId(params.data.id);
                        setIsSendEmailModalOpen(true);
                      }
                    }}
                  />
                </div>
              )}
            </div>
          );
        },
        sortable: false,
        filter: false,
        floatingFilter: false,
      },
    ],
    [
      updateInvoiceStatus,
      updatePaymentStatus,
      updateReceivedAmount,
      updateReceivedDate,
      updateConversionRate,
      canEditInvoice,
      canDownloadInvoice,
      canStrikeOff,
      canSendEmail,
    ],
  );
  const defaultColDef = useMemo(
    () => ({
      cellStyle: (params) => {
        if (params.node.rowPinned) {
          return { fontSize: "15px", fontWeight: "bold" };
        }
        return { fontSize: "14px" };
      },
      tooltipValueGetter: (params) => {
        if (params.data?.paymentStatus === "DEFAULTED") return null;
        return params.value;
      },
      sortable: true,
      filter: true,
      floatingFilter: true,
    }),
    [],
  );
    const onCloseExcelModal = () => {
    setOpenPopupExcel(false);
  };
  const renderTable = useCallback(
    () => (
      <div
        className="ag-theme-alpine"
        style={{
          height: "75vh",
          fontSize: "14px",
          marginLeft: "20px",
          marginRight: "20px",
          marginTop: "20px",
          fontFamily: "Arial, Helvetica, sans-serif",
          backgroundColor: "#FFFFFF",
        }}
      >
        <AgGridReact
          columnDefs={columnDefs}
          rowData={invoicesData}
          pagination={true}
          paginationPageSize={10}
          defaultColDef={defaultColDef}
          rowSelection="multiple"
          suppressLoadingOverlay={true}
          suppressCellFocus={true}
          suppressRowClickSelection={true}
          pinnedBottomRowData={currenySummary?.map(item => ({
            invoiceNumber: `Total Amount in  ${item.currency}`,
            totalAmount: item.receivedAmount,
            currency: item.currency,
          }))}
          enableCellTextSelection={true}
          tooltipShowDelay={300}
          enableBrowserTooltips={true}
          rowClassRules={{ "row-defaulted": (params) => params.data?.paymentStatus === "DEFAULTED" }}
          onCellMouseOver={(params) => {
            if (params.data?.paymentStatus === "DEFAULTED") {
              const reason = params.data?.reason || "No reason provided";
              const cell = params.event.target.closest(".ag-cell");
              if (cell) cell.setAttribute("title", `Strike off reason: ${reason}`);
            }
          }}
          onCellMouseOut={(params) => {
            const cell = params.event.target.closest(".ag-cell");
            if (cell) cell.removeAttribute("title");
          }}
        />
      </div>
    ),
     [columnDefs, defaultColDef, invoicesData, currenySummary],
  );
  const renderData = () => {
    switch (apiStatus) {
      case apiStatusConstants.inProgress:
        return <LoadingView />;
      case apiStatusConstants.success:
        return renderTable();
      case apiStatusConstants.failure:
        return <FailureView onClickRetry={onClickRetry} />;
      default:
        return null;
    }
  };

  const hasDraftInvoices = useMemo(() => {
    return invoicesData?.some(invoice => invoice.status === "DRAFT") || false;
  }, [invoicesData]);

  return (
    <div>
      <Header />
      <div className="d-flex ">
        <LeftNavBar />

        <div className="page-content-wrapper">
          <PageHeader>
            <PageHeaderName>Invoices</PageHeaderName>

            <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
              {canSequenceEdit && (
                <PrimaryButton width="180px"  onClick={openInvoiceNumberModal}>
                  Invoice Sequence Number
                </PrimaryButton>
              )}
              {canSendEmail && (
                <PrimaryButton
                  onClick={() => setIsSendEmailModalOpen(true)}
                  disabled={!hasDraftInvoices}
                >
                   Send All
                </PrimaryButton>
              )}
              {canDownloadAll && (
                <PrimaryButton onClick={() => DownloadAllInvoices()}>
                  {isDownloading ? "Downloading..." : "Download All "}
                </PrimaryButton>
              )}
              {canImportOrExport && (
                <PrimaryButton
                   width="150px"
                   style={{ marginLeft: "10px", marginRight: "10px" }}
                   onClick={() => setOpenPopupExcel(!openPopupExcel)}
                >
                  Import Excel Sheet
                </PrimaryButton>
              )}
            </div>
          </PageHeader>
          <div className="table-container">
            <div style={{display: "flex",justifyContent:"end", alignItems: 'center'}} >
              <div style={{
                border: '1px solid #de2235',
                borderRadius: '8px',
                boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                padding: '8px 12px',
                color: '#c81313',
                backgroundColor: '#fff8f8',
                marginRight: '10px',
                fontSize: '14px'
              }}>
                 Project revenue may be affected due to missing conversion rates.
              </div>
              {projectsAccessDenied ? (
                <div
                  title="You don't have the Projects permission — ask your admin to grant it to filter invoices by project."
                  style={{
                    border: '1px solid #de2235',
                    borderRadius: '8px',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                    padding: '8px 12px',
                    color: '#c81313',
                    backgroundColor: '#fff8f8',
                    marginRight: '10px',
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Projects permission required to filter by project
                </div>
              ) : (
                <select
                  className="selectElement"
                  value={selectedProject}
                  onChange={handleProjectChange}
                >
                  <option value="">All Projects</option>

                  {projectsData.map((project) => (
                    <option key={project.id} value={project.id}>
                      {project.name}
                    </option>
                  ))}
                </select>
              )}
              <select
                className="selectElement"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              >
                <option value="">Select Month</option>
                {MonthsData.map((eachMonth) => (
                  <option key={eachMonth.value} value={eachMonth.value}>
                    {eachMonth.label}
                  </option>
                ))}
                <option value="0">All Months</option>
              </select>
              <select
                className="selectElement"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
              >
                <option value="">Select Year</option>
                {yearsList.map((eachYear) => (
                  <option key={eachYear.value} value={eachYear.value}>
                    {eachYear.label}
                  </option>
                ))}
              </select>
            </div>
            {renderData()}
            </div>
        </div>
      </div>
      {/* Strike off Modal */}
      <div className="no-modal-mb">
        <PopupModal
          showModal={isStrikeOffModalOpen}
          modalName="Confirm Strike Off"
          closeBtn={cancelStrikeOff}
          marginBottom="0px"
        >
          <div>
            <p>
              Are you sure you want to strike off this invoice number?
            </p>
            <textarea
              placeholder="Enter reason for striking off..."
              rows={4}
              style={{ width: "100%", marginTop: "5px", padding: "8px", resize: "vertical" }}
              value={strikeOffReason}
              onChange={(e) => setStrikeOffReason(e.target.value)}
            />
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "center",
                marginTop: "15px",
              }}
            >
              <SecondaryButton onClick={cancelStrikeOff}>Cancel</SecondaryButton>
              <PrimaryButton onClick={confirmStrikeOff} disabled={!strikeOffReason.trim() || loadingStates.strikeOff}>
                {loadingStates.strikeOff ? "Submitting..." : "Submit"}
              </PrimaryButton>
            </div>
          </div>
        </PopupModal>
      </div>
      <div className="no-modal-mb">
        <PopupModal
          showModal={isSendEmailModalOpen}
          modalName="Confirm Email Sending"
          closeBtn={cancelSendEmail}
          marginBottom="0px"
        >
          <div>
            <h5>
              Are you sure you want to send {selectedInvoiceId ? 'email' : 'emails'} for {selectedInvoiceId ? 'invoice' : 'invoices'} in draft status?</h5>
            <div style={{ marginTop: "25px" }}>
              <StyledSelectGroup>
                        <StyledSelectContainer>
                          <StyledSelect
                            value={selectedTemplateId}
                            onChange={(e) => setSelectedTemplateId(e.target.value)}
                          >
                            <option value="">---Select Email Template---</option>
                            {emailTemplatesData?.map((template) => (
                              <option key={template.id} value={template.id}>
                                {template.templateName}
                              </option>
                            ))}
                          </StyledSelect>
                          <StyledLabel className="user-label">Email Template*</StyledLabel>
                        </StyledSelectContainer>
                      </StyledSelectGroup>
            </div>
            {emailTemplatesAccessDenied && (
              <p style={{ color: "#c81313", fontSize: "12px", marginTop: "5px" }}>
                You don't have the Email Templates permission — this is required to load templates for sending.
              </p>
            )}
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "end",
                marginTop: "15px",
              }}
            >
              <SecondaryButton onClick={cancelSendEmail}>No</SecondaryButton>
              <PrimaryButton onClick={handleSendEmail} disabled={!selectedTemplateId || loadingStates.sendInvoice}>
                {loadingStates.sendInvoice ? "Sending..." : "Send"}
              </PrimaryButton>
            </div>
          </div>
        </PopupModal>
      </div>
      <div className="no-modal-mb">
        <PopupModal
          showModal={isInvoiceSequenceNumberModalOpen}
          modalName="Invoice Sequence Number"
          closeBtn={cancelInvoiceNumberModal}
          marginBottom="0px"
          width="30vw"
        >
          <div>
            <p>Upcoming invoices will start from this sequence</p>
            {invoiceNumberAccessDenied && (
              <p style={{ color: "#c81313", fontSize: "12px" }}>
                You don't have the Invoice Sequence permission — this is required to view/edit the current sequence.
              </p>
            )}
            <input
              type="number"
              value={invoiceNumberInput}
              onChange={(e) => { setInvoiceNumberInput(e.target.value); setInvoiceNumberError(""); }}
              placeholder="Enter invoice number"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            />
            {invoiceNumberError && <p style={{ color: "#dc3545", fontSize: "13px", marginTop: "5px", marginBottom: "0px" }}>{invoiceNumberError}</p>}
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "flex-end",
                marginTop: "15px",
              }}
            >
              <SecondaryButton onClick={cancelInvoiceNumberModal}>Cancel</SecondaryButton>
              <PrimaryButton
                onClick={saveInvoiceNumber}
                disabled={!invoiceNumberInput || loadingStates.invoiceNumber}
              >
                {loadingStates.invoiceNumber ? "Saving..." : "Save"}
              </PrimaryButton>
            </div>
          </div>
        </PopupModal>
      </div>
      <PopupModal
          modalName="Upload File"
          closeBtn={onCloseExcelModal}
          showModal={openPopupExcel}
        >
          <UploadExcelForm
             onExport={() => exportInvoiceExcelTemplate(selectedMonth, selectedYear)}
             onImport={handleImport}
             exportFileName="resources.xlsx" 
             setOpenPopupExcel={setOpenPopupExcel}
             exportFileDescription="Download Invoice Data" />
             
        </PopupModal>
    </div>
  );
};

export default InvoiceManagementDashBoard;
